import { Fragment } from "react/jsx-runtime";
import { useWindowContext } from "./useWindowContext";
import { WindowInstances } from "./WindowInstances";
import { ActionTracker } from "src/common/managers/ActionTracker";
import React from "react";
import { AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { Actions, closeWindow, ManagedWindow, WindowId } from "./WindowState";
import { Localization } from "@viamap/viamap2-common";

export function WindowDisplayer() {
  const { state, dispatch } = useWindowContext();

  return state.map((w) => (
    <Fragment key={w.uid || w.id}>
      <WindowErrorBoundary window={w} dispatch={dispatch}>
        <WindowInstances window={w} />
      </WindowErrorBoundary>
    </Fragment>
  ));
}

export class WindowErrorBoundary extends React.Component<{ children: React.ReactNode, window: ManagedWindow, dispatch: React.Dispatch<Actions> }, { hasError: boolean, message: string, stackTrace: string }> {
  constructor(props: { children: React.ReactNode, window: ManagedWindow, dispatch: React.Dispatch<Actions> }) {
    super(props);
    this.state = {
      hasError: false,
      message: "",
      stackTrace: ""
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, message: error.message, stackTrace: error.stack || "" };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    ActionTracker.track("Error", "ErrorBoundary", "Window", {
      ErrorLocation: WindowId[this.props.window.id] || undefined,
      ErrorMessage: error.message || undefined,
      StackTrace: error.stack || undefined,
      ComponentStack: errorInfo.componentStack || undefined,
    })
  }

  render() {
    if (this.state.hasError) {
      return <>
        <AdvancedDragModal title={Localization.getText("window.errorboundary.title")}
          PosDefault={{
            left: "50%",
            top: "20%",
            width: "500px",
            transform: "translateX(-50%)"
          }}

          onClose={() => this.props.dispatch(closeWindow(this.props.window.id))}
        >
          <ADMErrorDisplay>
            <>
              {Localization.getFormattedText("window.errorboundary.errorInfoMessage", { windowName: WindowId[this.props.window.id] })}
              <br />
              <br />
              {Localization.getText("window.errorboundary.errorHelpMessage")}
              <br />
            </>
          </ADMErrorDisplay>
        </AdvancedDragModal >
      </>
    }
    return this.props.children;
  }
}

export function ADMErrorDisplay({ children }: { children: JSX.Element | string }) {
  return (
    <div className="ErrorDisplay">
      {children}
    </div>
  )
}